import { render } from "./evaluation-c++.vue?vue&type=template&id=24feaff1"
import script from "./evaluation-c++.vue?vue&type=script&lang=js"
export * from "./evaluation-c++.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__